export default __webpack_public_path__ + "static/media/products_524.e69a770a.jpg";